export class WebWorkerMessenger {
    send = (_message) => {
        // noop
    };
    broadcast = (message) => {
        this.send(message);
    };
}
